interface CouponCodeMatch {
  couponCode: string;
}

export function isValidCouponMatch(search: unknown): search is CouponCodeMatch {
  return Boolean(
    search && Object.prototype.hasOwnProperty.call(search, 'couponCode')
  );
}
